<template>
<div>
  <div>
    <div>
      <vs-row>
        <vs-col>
          <!-- Patient ID Row - Keep original structure -->
          <vs-row class="mb-1">
            <vs-col vs-lg="3" class="topPad">
              <span class="inputStyles">Patient Id *</span>
            </vs-col>
            <vs-col vs-lg="3" vs-md="6" vs-sm="12" >
              <vs-input ref="patientInput" type="text" style="width:100%; max-width:220px;" 
                :readonly="readonly" v-model="patientId" 
                @keydown.enter="$emit('fetchPatient', patientId)"
                @keydown.tab="$emit('fetchPatient', patientId)"/>
            </vs-col>
           
            <vs-col vs-lg="1" vs-md="2" vs-sm="2" class="icon-col p-0" style="display: flex; align-items: center;">     
              <div v-if="showSearchIcon == true" title="search">
                <SearchIcon class="custom-class" @click="searchPatient" style="margin-top:5px;cursor:pointer"/>
              </div>
            </vs-col>
             <vs-col vs-lg="1" vs-md="2" vs-sm="2" class="icon-col p-0" style="display: flex; align-items: center;margin-left:-15px">
              <div v-if="showAddIcon == true" title="add patient">
                <UserPlusIcon class="custom-class" @click="addPatient" style="margin-top:5px;cursor:pointer;"/>
              </div>
            </vs-col>
          </vs-row>

          <!-- Name Row -->
          <vs-row class="mb-1" style="margin-top: 1%;">
            <vs-col vs-lg="3" class="topPad">
              <span class="inputStyles">Name *</span>
            </vs-col>
            <vs-col vs-lg="4" vs-md="4" vs-sm="12" >
              <vs-input style="width:230px;" type="text" 
                :readonly="readonly" v-model="patientDetails.name" />
            </vs-col>
          </vs-row>

          <!-- Age and Sex Row - Keep original structure -->
        <!--  <vs-row class="mb-1" style="margin-top: 1%;">
            <vs-col vs-lg="3" vs-md="3" vs-sm="12" class="topPad">
              <span class="inputStyles">Age *</span>
            </vs-col>
            <vs-col vs-lg="2" vs-md="2" vs-sm="4" >
              <vs-input 
                style="width:90px; min-width:90px; max-width:90px;" 
                type="text" :readonly="readonly"
                v-model="patientDetails.age" />
            </vs-col>
            <vs-col vs-lg="1" vs-md="1" vs-sm="3" class="topPad" style="padding-left:5px">
              <span class="inputStyles">Sex<span>*</span></span>
            </vs-col>
            <vs-col vs-lg="2" vs-md="2" vs-sm="5" style="padding-left:0">
              <vs-input 
                style="width:90px; min-width:90px; max-width:90px; margin-left:-5px" 
                type="text" :readonly="readonly" 
                v-model="patientDetails.gender" />
            </vs-col>
          </vs-row>-->
          <!-- Age + Sex Row -->
<vs-row class="mb-1" style="margin-top: 1%;">
  <vs-col vs-lg="3" vs-md="3" vs-sm="12" class="topPad">
    <span class="inputStyles">Age *</span>
  </vs-col>

  <!-- Flex container for Age + Sex -->
  <vs-col vs-lg="6" vs-md="6" vs-sm="12">
    <div style="display:flex; align-items:center; gap:12px; flex-wrap:wrap;">
      
      <!-- Age input -->
      <vs-input 
        style="width:90px; min-width:90px;" 
        type="text" :readonly="readonly"
        v-model="patientDetails.age" />
      
      <!-- Sex input with label -->
      <div style="display:flex; align-items:center; gap:6px;">
        <span class="inputStyles">Sex *</span>
        <vs-input 
          style="width:90px; min-width:90px;" 
          type="text" :readonly="readonly"
          v-model="patientDetails.gender" />
      </div>

    </div>
  </vs-col>
</vs-row>

                <!-- Place Row -->
          <vs-row class="mb-1" style="margin-top: 1%;">
            <vs-col vs-lg="3" class="topPad">
              <span class="inputStyles">Place</span>
            </vs-col>
            <vs-col vs-lg="4" vs-md="4" vs-sm="12">
              <vs-input  style="width:230px;" 
                v-model="patientDetails.place" :readonly="readonly" />
            </vs-col>
          </vs-row>
          <!-- Phone No Row -->
          <vs-row class="mb-1" style="margin-top: 1%;">
            <vs-col vs-lg="3" class="topPad">
              <span class="inputStyles">Phone No{{this.$parent.opTicketData}}</span>
            </vs-col>
            <vs-col vs-lg="4" vs-md="4" vs-sm="12">
              <vs-input  style="width:230px;" type="text" 
                :readonly="readonly" v-model="patientDetails.phoneNo" />
            </vs-col>
          </vs-row>

    

        </vs-col>
      </vs-row>
    </div>
  </div>
</div>
</template>
<script>

import {
    SearchIcon,UserPlusIcon
} from 'vue-feather-icons'

export default {
    components: {
        SearchIcon,UserPlusIcon
    },
    props: {
        patientId: [Number, String],
        patientDetails: [Object, Array],
        iconShow:Boolean,
        showAddIcon:Boolean,
        showSearchIcon:Boolean,
        opData:[Object, Array],
        billData:[Object, Array],
        readonly: {
    type: Boolean,
    default: false
  },
  sourceType: {         
    type: String,
    default: 'op'       
  }
    },
    
    mounted(){
       this.$refs.patientInput.$el.querySelector('input').focus();
    },
    methods:{
        /*addPatient(){
            // this.tooltip('hide');
           var data={
                
                opData:this.opData,
                billData:this.billData
            }
            this.$store.dispatch('updateOpData', data);
            this.$router.push({
                path:'patientRegistration',
                    query: {
                        addFlag:'Y',
                    }
            });
        },*/
          addPatient() {
    if (this.sourceType === 'ip') {
      //  IP page logic
      this.$router.push({
        path: 'patientRegistration',
        query: { addFlag: 'Y', source: 'ip' }
      });
    } else {
      
      var data = {
        opData: this.opData,
        billData: this.billData
      };
      this.$store.dispatch('updateOpData', data);
      this.$router.push({
        path: 'patientRegistration',
        query: { addFlag: 'Y' }
      });
    }
  },
        searchPatient(){
             var data={
                
                opData:this.opData,
                billData:this.billData
            }
            this.$store.dispatch('updateOpData', data);
             this.$store.commit("updatepatientDashboardFilters", null);
            // this.tooltip('hide');
             this.$router.push({
                path:'patientDetailsDashboard',
                    query: {
                        searchFlag:'Y',
                         from: this.sourceType 
                    }
            }); 
        }
       
    }

}
</script>

<style scoped>

svg{
    width:20px;
    height:20px;
}
.patientData{
    padding-left: 4%;
    padding-right: 4%;
}
.inputStyles{
    font-size: 11.8px;
    font-weight: 600;
}
.topPad{
    padding-top: 7px;
}
@media (max-width: 768px) {
  .icon-col {
    display: inline-block;
    margin-left: 10px;
    margin-top: 0;
  }
  .topPad {
    padding-bottom: 5px;
  }
  .mb-1 {
    margin-bottom: 15px !important;
  }
}
</style>
